module.exports = __webpack_public_path__ + "img/result_bg.264c7acf.png";